import {AfterViewInit, Component, OnInit, ViewEncapsulation} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../services/auth.service';
import {catchError, mapTo, tap} from 'rxjs/operators';
import {of} from 'rxjs';
import {Router} from '@angular/router';
import { AppService } from '../../../app.service';


@Component({
    selector: 'ngx-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LoginComponent implements OnInit, AfterViewInit {
    form = new FormGroup({
        email: new FormControl('', [
            Validators.required,
            //Validators.email,
        ]),
        password: new FormControl('', [
            Validators.required,
            Validators.minLength(6),
            Validators.maxLength(10),
        ]),
    });
    isSubmited: boolean = false;
    public error = null;
    errorMessage: string;
    passwordVisible: boolean = false;

    // Lista de módulos del sistema para la rotación dinámica
    systemModules = [
      { name: 'Dashboard', description: 'Panel de control principal', icon: '📊' },
      { name: 'Plantilla', description: 'Gestión integral de empleados', icon: '👥' },
      { name: 'Vacaciones', description: 'Control de permisos y descansos', icon: '🏖️' },
      { name: 'Actas Administrativas', description: 'Documentos legales empresariales', icon: '📋' },
      { name: 'Seguridad e Higiene', description: 'Prevención y seguridad laboral', icon: '🛡️' },
      { name: 'Capacitación', description: 'Formación y desarrollo profesional', icon: '🎓' },
      { name: 'Asistencia', description: 'Control de entrada y salida', icon: '⏰' },
      { name: 'Catálogos', description: 'Departamentos, puestos y jornadas', icon: '📚' },
      { name: 'Litigios', description: 'Gestión de casos legales', icon: '⚖️' },
      { name: 'Mensajes', description: 'Comunicación interna', icon: '💬' },
      { name: 'Mis Documentos', description: 'Gestión documental personal', icon: '📁' },
      { name: 'Usuarios', description: 'Administración de accesos', icon: '👤' },
      { name: 'Empresa', description: 'Configuración empresarial', icon: '🏢' },
      { name: 'Documentos', description: 'Gestión general de archivos', icon: '📄' },
      { name: 'Permisos', description: 'Control de acceso y roles', icon: '🔐' },
      { name: 'Contacto', description: 'Comunicación y soporte', icon: '📞' },
      { name: 'Configuración', description: 'Ajustes del sistema', icon: '⚙️' }
    ];

    currentModuleIndex = 0;

    constructor(
        private authService: AuthService,
        private router: Router,
        private service: AppService,
    ) {
      //Se forza porque si no se quedaba en cache datos de sesion anterior
      if (localStorage.getItem('refreshed') === null) {
        localStorage['refreshed'] = true;
        window.location.reload();
      } else {
        localStorage.removeItem('refreshed');
      }
    }
  /* tslint:disable:no-console */
    public onSubmit() {
        this.isSubmited = true;
        const body = {email: this.form.value.email.toLowerCase(), password: this.form.value.password};
        this.authService.login(body).pipe(
            tap((tokens: any) => this.authService.doLoginUser(this.form.value.email, tokens)),
            mapTo(true),
            catchError(error => {
                this.handleError(error);
                return of(false);
            })).subscribe(
            res => {
                try {
                  if (res) {
                    setTimeout(() => {
                      const dataUser = JSON.parse(localStorage.getItem('USER_CURRENT'));
                      if (dataUser.tipo != "checkin") {
                        this.router.navigate(['/pages']).then(() => {
                          this.isSubmited = false;
                        });
                      } else {
                        this.router.navigate(['/asistencia/asistencia']).then(() => {
                          this.isSubmited = false;
                        });
                      }
                    }, 500);
                  }
                  else {
                    this.isSubmited = false;
                  }
                } catch (e) {
                  //console.log('edit_route fail redirect ', e);
                }
            },
            err => {
                this.isSubmited = false;
                //console.log(err);
            },
        );
    }
  /* tslint:enable:no-console */

    handleError(error) {
      switch (error.status) {

        case 401:
          this.setErrorMessage('No estás autenticado. Por favor, inicia sesión.');
          break;
        case 403:
          this.setErrorMessage('No tienes permiso para acceder a este recurso.');
          break;
        case 404:
          this.setErrorMessage('El recurso solicitado no se encontró.');
          break;
        case 500:
          this.setErrorMessage('Ocurrió un error en el servidor. Por favor, inténtalo de nuevo más tarde.');
          break;
        default:
          this.error = error.error.error;
          this.setErrorMessage('Ocurrió un error: ' + error.error.error);
      }
    }
    private setErrorMessage(message: string) {
      this.errorMessage = message;
      setTimeout(() => {
        this.errorMessage = null;
      }, 10000); // Ocultar el mensaje después de 5 segundos
    }
    ngOnInit(){
      this.startModuleRotation();
    }
    ngAfterViewInit(): void {
    // Safari-compatible header initialization
    setTimeout(() => {
      this.initHeader();
    }, 100);
    // Resetear solo los campos de credenciales
    this.form.reset({ email: '', password: '' });
  }

  // Función para rotar los módulos infinitamente
  startModuleRotation() {
    setInterval(() => {
      this.currentModuleIndex = (this.currentModuleIndex + 1) % this.systemModules.length;
    }, 3000); // Cambia cada 3 segundos
  }

  // Obtener el módulo actual
  get currentModule() {
    return this.systemModules[this.currentModuleIndex];
  }

  // Obtener el siguiente módulo para la transición
  get nextModule() {
    const nextIndex = (this.currentModuleIndex + 1) % this.systemModules.length;
    return this.systemModules[nextIndex];
  }

  private initHeader(): void {
    try {
      const width = window.innerWidth;
      let height = window.innerHeight;
      
      // Safari specific height fix
      if (this.isSafari()) {
        height = Math.max(height, 640);
        // Use viewport height for Safari
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
      } else {
        if (height < 640) {
          height = 640;
        }
      }
      
      const largeHeader = document.getElementById('large-header');
      if (largeHeader) {
        largeHeader.style.height = height + 'px';
      }
    } catch (error) {
      console.warn('Error initializing header:', error);
    }
  }

  private isSafari(): boolean {
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.includes('safari') && !userAgent.includes('chrome');
  }

  togglePasswordVisibility(): void {
    this.passwordVisible = !this.passwordVisible;
  }
}
